import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
// import ColorPicker from "../../components/colorpicker";
import { callReadOnlyFunction, stringAsciiCV, cvToValue } from '@stacks/transactions';
import { Alert, Snackbar } from "@mui/material";
import { getUserData } from "../../services/auth";
import { clientNetwork, sentimentApi, stacksApi, stacksExplorer } from "../../lib/constants";
import ContractCosts from "./ContractCosts";
import { deleteUploads, save } from "../../services/stacks";
import ConfirmDefaultModal from "../../components/modal/ConfirmDefaultModal";
import ActivateInterface from "./ActivateInterface";
import { network } from '../../services/auth';
import './style.scss';

const appOrigin = window.location.origin;
const Settings = ({ userSettings, setUserSettings }) => {
  const [apiValue, setApiValue] = useState("");
  const [explorerValue, setExplorerValue] = useState("");
  const [sentimentValue, setSentimentValue] = useState("");
  const [apiSaveBtn, setApiSaveBtn] = useState(true);
  const [costAdmin, setCostAmin] = useState('');
  // const [selectedColor, setSelectedColor] = useState('');
  //Snackbar close handler
  const [showConfirmDefaultModal, setShowDefaultModal] = useState(false);
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [errorMsg, setErrorMsg] = useState({ severity: 'info', msg: '' });
  function handleCloseSnackBar() { setOpenSnackBar(false); };

  const authorPrincipal = getUserData().profile.stxAddress.testnet;
  //const authorPrincipal = getUserData().profile.stxAddress.mainnet;

  // Setup for Link
  const navigate = useNavigate();

  const determineApiProtocol = (input) => {
    input.length > 7 && input.includes('https://')
    console.log('===>>>', input, input.includes('https://'));
    setApiSaveBtn(!input.includes('https://'));
  };

  const handleApiChange = (event) => {
    const { value } = event.target;
    determineApiProtocol(value);
    setApiValue(value);
  };

  const handleExplorerChange = (event) => {
    const { value } = event.target;
    determineApiProtocol(value);
    setExplorerValue(value);
  };

  const handleSentimentChange = (event) => {
    const { value } = event.target;
    determineApiProtocol(value);
    setSentimentValue(value);
  };


  function handleApiSave() {
    save({ fileName: 'settings.json', content: JSON.stringify({ stacksApi: apiValue, stacksExplorer: explorerValue, sentimentApi: sentimentValue }) }, { encrypt: false })
      .then(({ success, result }) => {
        if (success) {
          setErrorMsg({ severity: 'success', msg: 'Settings updated successfully!' });
          setUserSettings({ stacksApi: apiValue, stacksExplorer: explorerValue, sentimentApi: sentimentValue });
          localStorage.setItem(appOrigin, JSON.stringify({ stacksApi: apiValue, stacksExplorer: explorerValue, sentimentApi: sentimentValue }));
        } else {
          setErrorMsg({ severity: 'error', msg: 'Settings updated failed!' });
        }
        setOpenSnackBar(true);
      })
  }

  function handleResetSettings() {
    deleteUploads('settings.json')
      .then(({ success, result }) => {
        if (success) {
          setErrorMsg({ severity: 'success', msg: 'Settings reset successfully!' });
          setUserSettings({ stacksApi: '', stacksExplorer: '', sentimentApi: '' });
          localStorage.removeItem(appOrigin);
          setShowDefaultModal(false);
        } else {
          setErrorMsg({ severity: 'error', msg: 'Settings reset failed!' });
        }
      })
  }

  function handleReset() {
    setShowDefaultModal(true);
  }

  // //Handle the Color Picker Selected Color
  // const handleChange = color => {
  //   setSelectedColor(color);
  // };

  // useEffect(() => {
  //   determineApiProtocol(apiValue || explorerValue || sentimentValue);
  // }, [apiValue, explorerValue, sentimentValue])

  useEffect(() => {
    async function init() {
      const bro = await callReadOnlyFunction({
        contractAddress: 'SP3VTSYAD7E789BJA2BAX93PYFFZFVK1H39X5D8YS',
        contractName: 'derupt-feed',
        functionName: 'view-crypto-bros',
        functionArgs: [stringAsciiCV('cryptodude')],
        senderAddress: authorPrincipal,
        network
      });
      setCostAmin(cvToValue(bro?.value));
    }
    init();
  }, [])

  return (
    <>
      <div className="settings-container">
        {/* <div className="settings-row">
          <ColorPicker selectedColor={selectedColor} />
        </div> */}

        <div className="settings-row">
          <ActivateInterface />
        </div>

        <div className="settings-row">
          <TextField type="text" className="settings-field" id="api" aria-readonly fullWidth variant="filled" color="secondary"
            error={apiValue.length > 7 && !apiValue.includes('https://')}
            value={apiValue} onChange={handleApiChange} onClick={handleApiChange}
            helperText={apiValue.length > 7 && !apiValue.includes('https://') ? "Must begin with https://." : "Stacks API"}
            placeholder={userSettings?.stacksApi || stacksApi} />
        </div>

        <div className="settings-row">
          <TextField type="text" id="explorer" className="settings-field" aria-readonly fullWidth variant="filled" color="secondary"
            error={explorerValue.length > 7 && !explorerValue.includes('https://')}
            value={explorerValue} onChange={handleExplorerChange} onClick={handleExplorerChange}
            helperText={explorerValue.length > 7 && !explorerValue.includes('https://') ? "Must begin with https://." : "Stacks Explorer"}
            placeholder={userSettings?.stacksExplorer || stacksExplorer} />
        </div>

        <div className="settings-row">
          <TextField type="text" id="explorer" className="settings-field" aria-readonly fullWidth variant="filled" color="secondary"
            error={sentimentValue.length > 7 && !sentimentValue.includes('https://')}
            value={sentimentValue} onChange={handleSentimentChange} onClick={handleSentimentChange}
            helperText={sentimentValue.length > 7 && !sentimentValue.includes('https://') ? "Must begin with https://." : "Stacks Sentiment"}
            placeholder={userSettings?.sentimentApi || sentimentApi}
          />
        </div>

        <div className="settings-row">
          <button className={apiSaveBtn ? 'settings-button-disable' : "settings-button"} disabled={apiSaveBtn} onClick={handleApiSave}>Apply Settings</button>
          <button className={(userSettings?.stacksApi || userSettings?.stacksExplorer || userSettings?.sentimentApi) ? "settings-button" : 'settings-button-disable'} disabled={(userSettings?.stacksApi || userSettings?.stacksExplorer || userSettings?.sentimentApi) ? false : true} onClick={handleReset}>Default Settings</button>
        </div>

        <div className="settings-row">
          <button className="settings-button" onClick={() => navigate(`/muted`)}>Manage Muted</button>
        </div>
        <div className="settings-row">
          {authorPrincipal === costAdmin ? <ContractCosts /> : null}
        </div>

      </div>

      {/* Snack bar joint */}
      <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={handleCloseSnackBar}>
        <Alert onClose={handleCloseSnackBar} severity={errorMsg.severity} sx={{ width: '100%' }}>
          {errorMsg.msg}
        </Alert>
      </Snackbar>

      <ConfirmDefaultModal show={showConfirmDefaultModal} setShow={setShowDefaultModal} action={handleResetSettings} close={() => setShowDefaultModal(false)} />
    </>
  );
};

export default Settings;
